import { Grid, Stack } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import { booleanSimNao, formatChoiceText, formatText } from 'utils/text.util'
import {
  HearingIdentificationType,
  substances,
  TeenagerIdentificationType,
} from '../../../types/hearing-identification.type'
import {
  formatWelcomedOtherReasons,
  validateChoiceField,
  validateStringNumber,
} from 'components/HearingSummary/utils/validate-field.util'

type TabContentProps = {
  data: HearingIdentificationType
}

export const TabHealthContent: React.FC<TabContentProps> = ({ data }) => {
  const hasWecomedInRJ =
    data &&
    data.identificacaoAdolescente &&
    booleanSimNao(data.identificacaoAdolescente.acolhidoInsticionalmenteEstadoRJ)

  const formatSubstances = (item: TeenagerIdentificationType): string => {
    const substancesArray = substances
      .filter((substance) => item[substance.name] === 'S')
      .map((substance) => substance.label)

    const lastItem = substancesArray.pop()

    if (substancesArray.length > 0) {
      return [substancesArray.join(', '), lastItem ? lastItem : ''].join(' e ')
    }

    return formatText(lastItem)
  }

  return (
    <Grid item xs={12}>
      <Stack direction='column' spacing={2}>
        <Field
          label='Faz algum tratamento de saúde mental?'
          value={[formatChoiceText(data.identificacaoAdolescente.tratamentoMental)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.tratamentoMental) && (
          <>
            <Field
              label='Tratamento de saúde mental:'
              value={[formatText(data.identificacaoAdolescente.tipoTratamentoMental)]}
              direction='row'
            />
            <Field
              label='Instituição de tratamento de saúde mental:'
              value={[formatText(data.identificacaoAdolescente.instituicaoTratamentoMental)]}
              direction='row'
            />
          </>
        )}
        <Field
          label='Faz uso de alguma substância?'
          value={[formatChoiceText(data.identificacaoAdolescente.usaSubstancia)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.usaSubstancia) && (
          <Field
            label='Qual(ais) substâncias:'
            value={[formatSubstances(data.identificacaoAdolescente)]}
            direction='row'
          />
        )}
        <Field
          label='Já foi acolhido institucionalmente?'
          value={[formatChoiceText(data.identificacaoAdolescente.acolhidoInsticionalmente)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.acolhidoInsticionalmente) && (
          <>
            <Field
              label='Rio de Janeiro?'
              value={[
                validateChoiceField(data.identificacaoAdolescente.acolhidoInsticionalmenteEstadoRJ),
              ]}
              direction='row'
            />
            {!hasWecomedInRJ && (
              <Field
                label='Estado:'
                value={[
                  validateStringNumber(
                    data.identificacaoAdolescente.descricaoIdAcolhidoInsticionalmenteOutroEstado,
                  ),
                ]}
                direction='row'
              />
            )}
            {hasWecomedInRJ && (
              <>
                <Field
                  label='Município:'
                  value={[
                    validateStringNumber(
                      data.identificacaoAdolescente
                        .descricaoIdAcolhidoInsticionalmenteMunicipioEstadoRJ,
                    ),
                  ]}
                  direction='row'
                />
                <Field
                  label='Instituição:'
                  value={[
                    validateStringNumber(
                      data.identificacaoAdolescente
                        .descricaoIdAcolhidoInsticionalmenteServicoAcolhimento,
                    ),
                  ]}
                  direction='row'
                />
              </>
            )}

            <Field
              label='Qual o motivo:'
              value={[formatWelcomedOtherReasons(data.identificacaoAdolescente)]}
              direction='row'
            />
          </>
        )}
      </Stack>
    </Grid>
  )
}
